import { render, staticRenderFns } from "./ForgotPasswordSuccess.vue?vue&type=template&id=58d705ee&scoped=true&"
import script from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordSuccess.vue?vue&type=style&index=0&id=58d705ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d705ee",
  null
  
)

export default component.exports